import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { API } from '@/utils/api';

const TEAM = '__team__';
export const empName = (e) => `${e.first_name || ''} ${e.last_name || ''}`.trim() || e.name || e.email || 'Employé';

// value = employee id ('' = whole team); onChange(id, name)
export const EmployeeSelect = ({ value, onChange, testid = 'employee-select', teamLabel = 'Équipe atelier' }) => {
  const [list, setList] = useState([]);
  useEffect(() => {
    axios.get(`${API}/employees`).then(r => setList((r.data || []).filter(e => e.is_active !== false && !e.is_admin))).catch(() => setList([]));
  }, []);
  return (
    <Select value={value || TEAM} onValueChange={v => (v === TEAM ? onChange('', teamLabel) : onChange(v, empName(list.find(e => e.id === v) || {})))}>
      <SelectTrigger data-testid={testid}><SelectValue placeholder={teamLabel} /></SelectTrigger>
      <SelectContent className="z-[90]">
        <SelectItem value={TEAM}>{teamLabel}</SelectItem>
        {list.map(e => <SelectItem key={e.id} value={e.id} data-testid={`${testid}-opt-${e.id}`}>{empName(e)}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};
